// Resultado final para elegir el banner en comercios.
export enum BannerOutcome {
  ACTIVATED = "activated",
  DENIED = "denied",
  COUNTER_OFFER = "counterOffer",
  COUNTER_OFFER_REJECTED = "counterOfferRejected",
  BELENDER_OR_HIGH_AMOUNT = "belenderOrHighAmount",
}

export interface BannerOutcomePayload {
  amount?: number;
  proposalId?: string;
}

const PostMessageService = {
  // Notifica a Comercios el resultado final para elegir el banner.
  BannerOutcome: (
    outcome: BannerOutcome,
    payload: BannerOutcomePayload = {}
  ) => {
    const event = {
      message: "Pepper - Banner Outcome",
      outcome,
      ...payload,
    };
    window.parent.postMessage(event, "*");
  },
  closeCEX: () => {
    const event = {
      message: "close CEX",
    };
    window.parent.postMessage(event, "*");
  },
  ProposalCreated: (uuid?: string) => {
    const event = {
      message: "Pepper - Proposal Created",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  OcrSuccessful: (uuid?: string) => {
    const event = {
      message: "Pepper - Ocr Success",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  PaymentInitiated: (uuid?: string) => {
    const event = {
      message: "Pepper - Payment Initiated",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  PaymentRetried: (uuid?: string) => {
    const event = {
      message: "Pepper - Payment Retried",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  PaymentFailed: (uuid?: string) => {
    const event = {
      message: "Pepper - Payment Error",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  PaymentSuccessful: (uuid?: string) => {
    const event = {
      message: "Pepper - Payment Success",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  BankReaderInitiated: (uuid?: string) => {
    const event = {
      message: "Pepper - BankReader Initiated",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  BankReaderRetried: (uuid?: string) => {
    const event = {
      message: "Pepper - BankReader Retried",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  BankReaderFailed: (uuid?: string) => {
    const event = {
      message: "Pepper - BankReader Error",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  BankReaderSuccessful: (uuid?: string) => {
    const event = {
      message: "Pepper - BankReader Success",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  InvalidOTP: (uuid?: string) => {
    const event = {
      message: "Pepper - Signature Wrong OTP",
      status: "Pending",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  ResendOTP: () => {
    //Se realiza desde cada librería y no se puede controlar aquí
    const event = {
      message: "Pepper - Signature OTP Resend",
      status: "Pending",
    };
    window.parent.postMessage(event, "*");
  },
  FinancingCompleted: (uuid?: string) => {
    const event = {
      message: "Pepper - Signature Success",
      status: "OK",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  FinancingDenied: (uuid?: string) => {
    const event = {
      message: "Pepper - Denied",
      status: "KO",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  FinancingCanceled: (uuid?: string) => {
    const event = {
      message: "Pepper - Canceled",
      status: "KO",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  FinancingFailed: (uuid?: string) => {
    const event = {
      message: "Pepper - Error",
      status: "KO",
      proposalId: uuid || "",
    };
    window.parent.postMessage(event, "*");
  },
  SignatureContract: (contractString: string) => {
    const event = {
      message: "Pepper - Signature Contract",
      contractString: contractString,
    };
    window.parent.postMessage(event, "*");
  },
};

export default PostMessageService;
